module.exports = __webpack_public_path__ + "static/media/buildWalls.7972bf6f.gif";